import { jsx as i } from "react/jsx-runtime";
import { c as t } from "react/compiler-runtime";
import { CircularProgress as l } from "@mui/material";
function p(e) {
  const r = t(4);
  let o;
  r[0] !== e ? ({
    ...o
  } = e, r[0] = e, r[1] = o) : o = r[1];
  let s;
  return r[2] !== o ? (s = /* @__PURE__ */ i(l, { ...o }), r[2] = o, r[3] = s) : s = r[3], s;
}
export {
  p as CircularProgress
};
